$(function () {
    var $tagFilter = $('#tagFilter');

    if ($tagFilter.length && !$tagFilter.data('tagFilterBound')) {
        $tagFilter.data('tagFilterBound', true);

        var $checkboxes = $tagFilter.find('input[type="checkbox"]');
        var $pills = $tagFilter.find('.tag-pill');

        $checkboxes.on('change', function () {
            $(this).closest('.tag-pill').toggleClass('is-selected', this.checked);
        });

        var $pillsBox = $tagFilter.find('.tag-filter-pills');
        var $fade = $tagFilter.find('.tag-filter-fade');
        var $toggle = $tagFilter.find('.tag-filter-toggle');
        var collapsedMaxHeight = 220;
        var isExpanded = false;

        var pillsOverflow = function () {
            return $pillsBox.length && $pillsBox[0].scrollHeight > collapsedMaxHeight + 4;
        };

        var refreshToggle = function () {
            if (!$pillsBox.length) {
                return;
            }

            if (!pillsOverflow() && !isExpanded) {
                $fade.hide();
                $toggle.hide();

                return;
            }

            $toggle.show().text(isExpanded ? $toggle.data('show-less') : $toggle.data('show-more'));
            $fade.toggle(!isExpanded);
        };

        refreshToggle();

        $toggle.on('click', function () {
            isExpanded = !isExpanded;

            $pillsBox.toggleClass('is-expanded', isExpanded);

            refreshToggle();
        });

        var $tagSearchInput = $tagFilter.find('.tag-filter-search-input');

        $tagSearchInput.on('keyup', function () {
            var query = $(this).val().toLowerCase().trim();

            $pills.each(function () {
                var $pill = $(this);
                var matches = $pill.data('tag-title').toString().indexOf(query) !== -1;

                $pill.toggle(matches);
            });

            if (query !== '') {
                $pillsBox.addClass('is-search-active');
                $fade.hide();
                $toggle.hide();
            } else {
                $pillsBox.removeClass('is-search-active');
                refreshToggle();
            }
        });
    }

    var $copyLink = $('.news-share-copy');

    if ($copyLink.length) {
        $copyLink.on('click', function () {
            var $button = $(this);
            var url = $button.data('url');

            if (!navigator.clipboard) {
                return;
            }

            navigator.clipboard.writeText(url).then(function () {
                var originalLabel = $button.attr('aria-label');

                $button.addClass('is-copied').attr('aria-label', $button.data('copied-text'));

                setTimeout(function () {
                    $button.removeClass('is-copied').attr('aria-label', originalLabel);
                }, 2000);
            });
        });
    }

});
